export default __webpack_public_path__ + "static/media/howItWorksStep1.a25c8bb1.svg";